module.exports = __webpack_public_path__ + "img/garbage-red.37635e68.svg";